import * as React from "react";
import { Edit, SimpleForm, TextInput, NumberInput, List, Datagrid, TextField, NumberField, DateField, Create, BooleanInput, BooleanField, SelectInput } from 'react-admin';
import { Box, Tabs, Tab, Typography } from '@material-ui/core';
import DayTypesImportForm from './components/DayTypesImportForm';

const DayTypesTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

const groupingChoices = [
    { id: 'work', name: 'Work' },
    { id: 'absent', name: 'Absent' },
];

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
};

export const DayTypesList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="code" />
            <TextField source="name" />
            <TextField source="grouping" label="Grouping" />
            <BooleanField source="is_shoot_day" label="Shoot Day" />
            <NumberField source="multiplier" />
            <BooleanField source="accrues_holiday" label="Accrues Holiday" />
            <NumberField source="holiday_accrual_multiplier" label="Hol. Accrual Multiplier" />
            <NumberField source="hol_ent_pay_multiplier" label="Hol. Ent. Pay Multiplier" />
            <NumberField source="flat_payment" label="Flat Payment" />
            <BooleanField source="show_on_calendar" label="Calendar" />
            <BooleanField source="show_on_timesheet" label="Timesheet" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);

export const DayTypesEdit = props => (
    <Edit {...props} title={<DayTypesTitle />} undoable={false}>
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <SelectInput source="grouping" choices={groupingChoices} />
            <BooleanInput source="is_shoot_day" label="Shoot Day" />
            <NumberInput source="multiplier" step={0.25} min={0} />
            <BooleanInput source="accrues_holiday" label="Accrues Holiday" />
            <NumberInput
                source="holiday_accrual_multiplier"
                label="Holiday Accrual Multiplier"
                step={0.25}
                min={0}
                helperText="How much holiday this day accrues when Accrues Holiday is on, e.g. 0.5 for a half day"
            />
            <NumberInput source="hol_ent_pay_multiplier" label="Hol. Ent. Pay Multiplier" step={0.25} min={0} />
            <NumberInput source="flat_payment" label="Flat Payment" step={0.01} min={0} />
            <BooleanInput source="show_on_calendar" label="Show on Calendar" />
            <BooleanInput source="show_on_timesheet" label="Show on Timesheet" />
        </SimpleForm>
    </Edit>
);

export const DayTypesCreate = props => {
    const [tab, setTab] = React.useState(0);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
                    <Tab label="Bulk Import" />
                    <Tab label="Manual Entry" />
                </Tabs>
            </Box>
            <TabPanel value={tab} index={0}>
                <DayTypesImportForm {...props} />
            </TabPanel>
            <TabPanel value={tab} index={1}>
                <Create {...props} title="New Day Type" undoable={false} redirect="list">
                    <SimpleForm redirect="list">
                        <TextInput source="code" />
                        <TextInput source="name" />
                        <SelectInput source="grouping" choices={groupingChoices} defaultValue="work" />
                        <BooleanInput source="is_shoot_day" label="Shoot Day" />
                        <NumberInput source="multiplier" step={0.25} min={0} defaultValue={1} />
                        <BooleanInput source="accrues_holiday" label="Accrues Holiday" />
                        <NumberInput
                            source="holiday_accrual_multiplier"
                            label="Holiday Accrual Multiplier"
                            step={0.25}
                            min={0}
                            defaultValue={0}
                            helperText="How much holiday this day accrues when Accrues Holiday is on, e.g. 0.5 for a half day"
                        />
                        <NumberInput source="hol_ent_pay_multiplier" label="Hol. Ent. Pay Multiplier" step={0.25} min={0} defaultValue={0} />
                        <NumberInput source="flat_payment" label="Flat Payment" step={0.01} min={0} defaultValue={0} />
                        <BooleanInput source="show_on_calendar" label="Show on Calendar" defaultValue={true} />
                        <BooleanInput source="show_on_timesheet" label="Show on Timesheet" defaultValue={true} />
                    </SimpleForm>
                </Create>
            </TabPanel>
        </Box>
    );
};
